// api/contributorAccess.js — Anamoria SPA
// v2.0 — Track B (B-2): LINKED-ONLY. The anonymous 'session' mode (session-token
//   client + '/contribute' prefix) is retired along with api/contributorApi.js;
//   contributors now resolve solely via the Auth0 JWT rail. Was v1.0 (dual-mode).
//
// A logged-in user who linked their account to an invite: auth via the in-memory
// Auth0 JWT (createApiClient), path prefix '/me/contributions'. NO sessionStorage
// token is ever involved.
//
// SECURITY INVARIANT (R-ADAPTER): client and prefix are returned together as a
// single unit. Callers must build request paths only as `${prefix}/${spaceId}/...`
// using the returned prefix — never hardcode.
//
// Usage:
//   import { getContributorAccess } from '../api/contributorAccess';
//   const { api, prefix } = getContributorAccess('linked', getAccessTokenSilently);
//   const data = await api.get(`${prefix}/${spaceId}/memories`);

import { createApiClient } from './client';

export const CONTRIBUTOR_MODES = {
  linked: 'linked',
};

/**
 * Return the JWT API client + path prefix bound together (linked mode only).
 *
 * @param {'linked'} [mode] - accepted for call-site compatibility; only 'linked' is supported.
 * @param {Function} getAccessTokenSilently - required (from useAuth0()).
 * @returns {{ mode: string, api: object, prefix: string }}
 */
export function getContributorAccess(mode, getAccessTokenSilently) {
  if (typeof getAccessTokenSilently !== 'function') {
    // Linked mode requires the Auth0 token-getter. Failing loud here prevents a
    // silent fallback that could mismatch client and prefix.
    throw new Error('getContributorAccess: linked mode requires getAccessTokenSilently');
  }
  return {
    mode: CONTRIBUTOR_MODES.linked,
    api: createApiClient(getAccessTokenSilently),
    prefix: '/me/contributions',
  };
}
